module.exports = __webpack_public_path__ + "c_static/img/京亨值.0f2f0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/截图示范/京亨值.png
// module id = c034
// module chunks = 33